module.exports = __webpack_public_path__ + "static/img/permit.f6b40a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/permit.png
// module id = YR4M
// module chunks = 1